import React from "react";
import { useAuth } from "../modules/auth/useAuth";
import { Navigate } from "react-router-dom";
import styled from "styled-components";

// Reuse styles from LoginPage or simple centered div
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: var(--x-bg-main, #0D0A12);
    color: var(--x-gray-200, #FFFFFF);
`;

const Callback = (): JSX.Element => {
  const auth = useAuth();

  // If authenticated, redirect to dashboard
  if (auth.isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // If error
  if (auth.error) {
    return (
      <Container>
        <h3>Authentication Error</h3>
        <p>{auth.error.message}</p>
        <button onClick={() => window.location.assign("/")}>Go Home</button>
      </Container>
    );
  }

  // Still loading or processing code
  return (
    <Container>
      <h3>Processing Login...</h3>
    </Container>
  );
};

export default Callback;
